import { push } from 'connected-react-router'

import { Specification } from '../api'

export const createSpecification = (identifier, format) => async (dispatch, getState) => {
  const token = getState().common.token
  await Specification(token).create(identifier, format)
  dispatch(push(`/specifications/${identifier}`))
}
